import gqlClient from '../gql';
import { logger } from '@/utils/log/logger';
import {
  GET_LIVE_COVERAGE_BY_ID,
  GET_LIVE_COVERAGES,
  liveCoverageVariables,
} from '../graphql';
import { Channel, LiveCoverageResponse, LiveCoveragesResponse } from '../model';
import { getAPILocale } from '@/utils';

export const getLiveCoverage = async (
  props: any,
  channel?: string,
): Promise<LiveCoverageResponse['LiveCoverage'] | undefined> => {
  try {
    const liveCoverageResponse = await gqlClient.query<LiveCoverageResponse>({
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
      query: GET_LIVE_COVERAGE_BY_ID,
      variables: liveCoverageVariables(props, channel),
    });

    return liveCoverageResponse?.data?.LiveCoverage;
  } catch (error) {
    logger.error(`Error getting live coverage: ${error}`);
  }
};

export const getAllLiveCoverages = async ({
  limit,
  channel,
  where = {},
}: {
  limit?: number;
  channel?: Channel;
  where?: any;
}): Promise<LiveCoveragesResponse | undefined> => {
  try {
    const liveCoverageResponse = await gqlClient.query<LiveCoveragesResponse>({
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
      query: GET_LIVE_COVERAGES,
      variables: {
        limit: limit || 1,
        locale: getAPILocale(channel?.languageCode),
        where: {
          channel: { equals: channel?.id },
          ...where,
        },
      },
    });

    return liveCoverageResponse?.data;
  } catch (error) {
    logger.error(`Error getting all live coverages: ${error}`);
  }
};
